<div class="form-wrapper-center-flex">
  <kendo-card [width]="'auto'">
    <kendo-card-body>
      <div>
        <form [formGroup]="passwordForm" class="k-form">
          <fieldset class="k-form-fieldset">
            <legend class="k-form-legend">
              {{ "FORGOT_PASSWORD_FORM.TITLE" | translate }}
            </legend>

            <kendo-formfield>
              <kendo-label
                [for]="email"
                [text]="'FORGOT_PASSWORD_FORM.EMAIL' | translate"
              ></kendo-label>
              <kendo-textbox
                showSuccessIcon="initial"
                showErrorIcon="initial"
                formControlName="email"
                #email
              >
              </kendo-textbox>
            </kendo-formfield>

            <div class="recaptcha-wrapper">
              <!--<re-captcha formControlName="recaptcha"></re-captcha>-->
            </div>
          </fieldset>
        </form>
      </div>
    </kendo-card-body>
    <hr kendoCardSeparator />
    <kendo-card-actions layout="end">
      <button routerLink="/auth/login" kendoButton fillMode="link">
        {{ "AUTH.LOGIN" | translate }}
      </button>
      <div class="k-spacer"></div>
      <button
        themeColor="primary"
        [disabled]="passwordForm.invalid"
        kendoButton
        fillMode="flat"
        (click)="submit()"
      >
        {{ "FORGOT_PASSWORD_FORM.SUBMIT" | translate }}
      </button>
    </kendo-card-actions>
  </kendo-card>
</div>
